<script setup lang="ts">
import MateBGLogo from '@/assets/images/logo-bg.svg';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { NEmpty } from '@nio-fe/lego'
import { repeat } from 'lodash-es';

interface MateEmptyProps {
  status: 'default' | 'loading';
}

const props = withDefaults(defineProps<MateEmptyProps>(), {
  status: 'default',
});
const currentHour = ref(new Date().getHours());
const loadingCnt = ref(1);
let intervalId;
let loadingIntervalId;
onMounted(() => {
  intervalId = setInterval(() => {
    currentHour.value = new Date().getHours();
  }, 10 * 60 * 1000);
  loadingIntervalId = setInterval(() => {
    loadingCnt.value = loadingCnt.value < 3 ? loadingCnt.value + 1 : 1;
  }, 1000);
});
onBeforeUnmount(() => {
  clearInterval(intervalId);
  clearInterval(loadingIntervalId);
});
const description = computed(() => {
  const time = currentHour.value;
  if (time < 12) {
    return '上午好,Mate与你一起加电哟！';
  } else if (time < 18) {
    return '下午好,来杯咖啡,打起精神哟！';
  } else if (time >= 18 && time < 22) {
    return '晚上好,辛苦了,Mate陪伴你哟！';
  } else {
    return '夜深了,注意休息哟！';
  }
});

const loadingText = computed(() => {
  return `加载中${repeat('.', loadingCnt.value)}`;
});
</script>

<template>
  <n-empty
    :size="120"
    :description="props.status === 'loading' ? loadingText : description"
    class="mate-empty"
  >
    <template #image>
      <div class="my-img">
        <img :src="MateBGLogo" alt="img" />
      </div>
    </template>
  </n-empty>
</template>

<style lang="scss">
.mate-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  box-sizing: border-box;
  padding: var(--n-empty-padding) 0;

  .n-empty__description {
    width: 450px !important;
    margin-top: 12px;
    font-size: 22px !important;
    line-height: 20px !important;
    color: #ced0d6;
    padding: 0 var(--n-empty-padding--description);
  }
}
</style>
